import { render, staticRenderFns } from "./main-home.vue?vue&type=template&id=490fed7f&"
import script from "./main-home.vue?vue&type=script&lang=js&"
export * from "./main-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports